import { render, staticRenderFns } from "./AccessGroups.vue?vue&type=template&id=7b0b5360&"
import script from "./AccessGroups.vue?vue&type=script&lang=js&"
export * from "./AccessGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports